import React, { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext(null);

export const TR = {
  it: {
    nav_articles: "Guide & Articoli",
    nav_reviews: "Attrezzatura",
    nav_blueprint: "Il Blueprint",
    nav_newsletter: "Newsletter",
    nav_login: "Accedi",
    cta_blueprint: "Inizia il Blueprint",
    hero_eyebrow: "Boxe · Kickboxing · Scienza dello Striking",
    hero_title: "Disciplina, meccanica e potenza. Senza filtri.",
    hero_sub: "Guide tecniche, recensioni oneste sull'attrezzatura e un programma di allenamento interattivo che si allena con te — non un altro PDF morto.",
    hero_cta_read: "Leggi le guide",
    hero_cta_product: "Scopri il Blueprint",
    featured: "In evidenza",
    latest: "Ultime guide",
    all_categories: "Tutte",
    read_more: "Leggi",
    min_read: "min di lettura",
    reviews_title: "Recensioni Attrezzatura",
    reviews_sub: "Test onesti. Link affiliati verificati e tracciati.",
    news_title: "Studi del Ring",
    news_sub: "Una sequenza di benvenuto di 5 giorni sulla meccanica dello striking. Zero spam.",
    news_placeholder: "La tua email",
    news_btn: "Iscriviti",
    news_done: "Sei nel ring! Controlla la tua email.",
    news_already: "Sei già iscritto.",
    footer_disclaimer: "I contenuti su tecnica e allenamento hanno scopo informativo. Allenati progressivamente e consulta un professionista in caso di dubbi o infortuni.",
    affiliate_note: "Questo articolo contiene link affiliati verificati. Acquistando tramite questi link potremmo ricevere una commissione, senza costi extra per te.",
    login_title: "Area Admin",
    login_btn: "Accedi",
    email: "Email",
    password: "Password",
    logout: "Esci",
    back: "Torna al sito",
    by: "di",
    views: "letture",
    // blueprint sales
    bp_eyebrow: "Il Prodotto · One-time",
    bp_title: "The 8-Week Striker Blueprint",
    bp_sub: "Non è un ebook. È una console di allenamento interattiva che gira mentre colpisci: timer con campana, generatore di combinazioni, checklist tecnica e log dei progressi.",
    bp_buy: "Sblocca il Blueprint",
    bp_have_access: "Ho già accesso",
    bp_features: "Perché non è il solito PDF",
    bp_email_label: "Email per l'accesso e la ricevuta",
    // console
    console_title: "Striker Console",
    tab_workouts: "Programmi",
    tab_timer: "Round Timer",
    tab_combos: "Generatore Combo",
    tab_checklist: "Checklist Tecnica",
    tab_log: "I Miei Log",
    start: "Avvia",
    pause: "Pausa",
    reset: "Reset",
    round: "Round",
    rest: "Recupero",
    rounds: "Round",
    round_len: "Durata round",
    rest_len: "Recupero",
    generate: "Genera combinazione",
    level: "Livello",
    beginner: "Principiante",
    intermediate: "Intermedio",
    advanced: "Avanzato",
    save_session: "Salva sessione",
    session_saved: "Sessione salvata!",
    checklist_intro: "Auto-valuta la tua tecnica da 0 a 5. Onestà = progresso.",
    submit_checklist: "Calcola punteggio",
    your_score: "Il tuo punteggio forma",
    no_logs: "Nessuna sessione registrata. Completa un round!",
    access_needed: "Accesso richiesto. Acquista il Blueprint o inserisci il tuo link di accesso.",
    verify_token: "Verifica accesso",
    complete: "COMPLETO",
    work: "LAVORO",
    nav_waitlist: "Lista d'attesa",
    wl_eyebrow: "Prossimo Prodotto · Validazione",
    wl_title: "Aiutaci a costruire il prossimo prodotto",
    wl_sub: "Prima di produrre qualcosa, testiamo la domanda. Iscriviti alla lista d'attesa e dicci cosa vorresti davvero.",
    wl_email: "La tua email",
    wl_note: "Cosa ti servirebbe di più? (facoltativo)",
    wl_btn: "Entra in lista",
    wl_done: "Sei in lista! Ti avviseremo per primo.",
    wl_already: "Sei già in lista.",
    wl_product_label: "Prodotto d'interesse",
    export_card: "Esporta scheda",
    promo_label: "Codice sconto",
    promo_apply: "Applica",
    promo_applied: "Sconto applicato!",
    promo_invalid: "Codice non valido",
    share: "Condividi",
    share_wa: "WhatsApp",
    share_ig: "Instagram",
    share_text: "La mia sessione sul Guardia Striker Blueprint 🥊",
    recover_title: "Non trovi il token? Recuperalo via email",
    recover_email_ph: "Email usata all'acquisto",
    recover_btn: "Inviami il link di accesso",
    recover_sent: "Se l'email corrisponde a un acquisto, riceverai il link di accesso a breve.",
  },
  en: {
    nav_articles: "Guides & Articles",
    nav_reviews: "Gear",
    nav_blueprint: "The Blueprint",
    nav_newsletter: "Newsletter",
    nav_login: "Log in",
    cta_blueprint: "Start the Blueprint",
    hero_eyebrow: "Boxing · Kickboxing · Striking Science",
    hero_title: "Discipline, mechanics and power. No filters.",
    hero_sub: "Technical guides, honest gear reviews and an interactive training program that trains with you — not another dead PDF.",
    hero_cta_read: "Read the guides",
    hero_cta_product: "Discover the Blueprint",
    featured: "Featured",
    latest: "Latest guides",
    all_categories: "All",
    read_more: "Read",
    min_read: "min read",
    reviews_title: "Gear Reviews",
    reviews_sub: "Honest tests. Verified, tracked affiliate links.",
    news_title: "Ring Studies",
    news_sub: "A 5-day welcome sequence on striking mechanics. Zero spam.",
    news_placeholder: "Your email",
    news_btn: "Subscribe",
    news_done: "You're in the ring! Check your email.",
    news_already: "You're already subscribed.",
    footer_disclaimer: "Technique and training content is for informational purposes. Train progressively and consult a professional if in doubt or injured.",
    affiliate_note: "This article contains verified affiliate links. If you buy through them we may earn a commission at no extra cost to you.",
    login_title: "Admin Area",
    login_btn: "Log in",
    email: "Email",
    password: "Password",
    logout: "Log out",
    back: "Back to site",
    by: "by",
    views: "views",
    bp_eyebrow: "The Product · One-time",
    bp_title: "The 8-Week Striker Blueprint",
    bp_sub: "It's not an ebook. It's an interactive training console that runs while you strike: bell round timer, combination generator, technical checklist and progress log.",
    bp_buy: "Unlock the Blueprint",
    bp_have_access: "I already have access",
    bp_features: "Why it's not the usual PDF",
    bp_email_label: "Email for access and receipt",
    console_title: "Striker Console",
    tab_workouts: "Programs",
    tab_timer: "Round Timer",
    tab_combos: "Combo Generator",
    tab_checklist: "Technical Checklist",
    tab_log: "My Logs",
    start: "Start",
    pause: "Pause",
    reset: "Reset",
    round: "Round",
    rest: "Rest",
    rounds: "Rounds",
    round_len: "Round length",
    rest_len: "Rest",
    generate: "Generate combination",
    level: "Level",
    beginner: "Beginner",
    intermediate: "Intermediate",
    advanced: "Advanced",
    save_session: "Save session",
    session_saved: "Session saved!",
    checklist_intro: "Self-rate your technique 0 to 5. Honesty = progress.",
    submit_checklist: "Compute score",
    your_score: "Your form score",
    no_logs: "No sessions logged yet. Complete a round!",
    access_needed: "Access required. Buy the Blueprint or enter your access link.",
    verify_token: "Verify access",
    complete: "COMPLETE",
    work: "WORK",
    nav_waitlist: "Waitlist",
    wl_eyebrow: "Next Product · Validation",
    wl_title: "Help us build the next product",
    wl_sub: "Before we produce anything, we test demand. Join the waitlist and tell us what you'd actually want.",
    wl_email: "Your email",
    wl_note: "What would help you most? (optional)",
    wl_btn: "Join the waitlist",
    wl_done: "You're on the list! We'll notify you first.",
    wl_already: "You're already on the list.",
    wl_product_label: "Product of interest",
    export_card: "Export card",
    promo_label: "Discount code",
    promo_apply: "Apply",
    promo_applied: "Discount applied!",
    promo_invalid: "Invalid code",
    share: "Share",
    share_wa: "WhatsApp",
    share_ig: "Instagram",
    share_text: "My session on the Guardia Striker Blueprint 🥊",
    recover_title: "Can't find your token? Recover it by email",
    recover_email_ph: "Email used at purchase",
    recover_btn: "Send me the access link",
    recover_sent: "If the email matches a purchase, you'll receive the access link shortly.",
  },
};

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window !== "undefined") {
      const q = new URLSearchParams(window.location.search).get("lang");
      if (q === "it" || q === "en") return q;
    }
    return localStorage.getItem("guardia_lang") || "it";
  });
  useEffect(() => {
    localStorage.setItem("guardia_lang", lang);
  }, [lang]);
  const t = (key) => (TR[lang] ?? TR.it)?.[key] ?? key;
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
